import axios from "axios";
import { API_URL2 } from "./constants";

const API = axios.create({
  baseURL: `${API_URL2[process.env.NODE_ENV]}`,
  timeout: 10000,
  headers: {
    authorization: `${localStorage.getItem("accesstokenhotelparkmall")}`,
  },
});

export default API;
